import { useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { IconEdit, IconTrash } from '@tabler/icons-react';
import { showConfirm } from "store/confirm/actions";
import { deleteTag, setSelectedTag, showTagModal } from "store/tags/actions";


const TagsTable = () => {
    const dispatch = useDispatch();
    const tags = useSelector((state) => state?.tags?.filteredTags);
    const isLoading = useSelector((state) => state?.tags?.isLoading);

    const handleDelete = useCallback(
        (id, tag) => () => {
            dispatch(showConfirm("Delete", `Are you sure you want to remove "${tag.name}" ?`, deleteTag, [id, tag.name]));
        },
        []
    );

    const handleEdit = useCallback(
        (selectedTag) => () => {
            dispatch(setSelectedTag(selectedTag))
            dispatch(showTagModal())
        },
        []
    );

    const columns = useMemo(() =>
    ([
        {
            field: "id",
            headerName: "#ID",
            headerAlign: "center",
            align: "center",
            width: 80,
            flex: 0.2,
        },
        {
            field: "name",
            headerName: "Name",
            headerAlign: "center",
            align: "center",
            width: 90,
            flex: 0.2,
        },
        {
            field: "language",
            headerName: "Language",
            headerAlign: "center",
            align: "center",
            width: 80,
            flex: 0.15,
        },
        {
            field: "priority",
            headerName: "Priority",
            headerAlign: "center",
            align: "center",
            width: 120,
            flex: 0.15,
        },
        {
            field: "organizationId",
            headerName: "Organization Id",
            headerAlign: "center",
            align: "center",
            width: 120,
            flex: 0.25,
            valueGetter: (params) => {
                return params.value ? params.row?.organizationName : "Public"
            }
        },
        {
            field: 'actions',
            type: 'actions',
            width: 100,
            flex: 0.2,
            getActions: (params) => [
                <GridActionsCellItem
                    sx={{
                        marginRight: '20px'
                    }}
                    icon={<IconTrash stroke={1.75} size="1.3rem" />}
                    title="Delete Tag"
                    label="Delete"
                    onClick={handleDelete(params.id, params.row)}
                    showInMenu={window.innerWidth <= 768}
                />,
                <GridActionsCellItem sx={{
                    marginRight: '20px'
                }}
                    icon={<IconEdit stroke={1.75} size="1.3rem" />}
                    title="Edit Organization"
                    label="Edit"
                    onClick={handleEdit(params.row)}
                    showInMenu={window.innerWidth <= 768}
                />,
            ],
        },
    ]), []);


    return (
        <Box sx={{ height: 670, width: '100%' }}>
            <DataGrid
                getRowId={(row) => row.id}
                rows={isLoading ? [] : tags}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 25,
                        },
                    },
                }}
                pageSizeOptions={[10, 25, 50, 100]}
                loading={isLoading}
            />
        </Box>
    );
};

export default TagsTable;